import { computed, type Ref } from 'vue'
import type { Praeparat } from '@/types/otc/praeparat'
import type { Artikel } from '@/types/otc/artikel'

export function useSharedProductData(praeparat: Ref<Praeparat | null>) {
    const artikelList = computed<Artikel[]>(() => (praeparat.value?.artikel || []) as Artikel[])

    const hasMultipleArtikel = computed(() => artikelList.value.length > 1)

    const firstArtikel = computed<Artikel | undefined>(() => artikelList.value[0])

    const isZuzahlungsbefreit = computed(() => firstArtikel.value?.isZuzahlungsbefreit ?? false)

    return {
        artikelList,
        hasMultipleArtikel,
        firstArtikel,
        isZuzahlungsbefreit
    }
}